module.exports = __webpack_public_path__ + "img/01-capsule-1.e1c2f866.svg";